import { createStyles, mapColorNameAndIndexToValue, mediaHelper, rem } from '@affstore-ds/uikit'

import { getLevelColors } from '../../lib/utils/getLevelColors'

export const useLevelBadgeStyles = createStyles((theme, { levelName }: { levelName?: string }) => {
  const { accent, contrast } = getLevelColors(levelName)
  const contrastColor = mapColorNameAndIndexToValue(theme.other.colors, contrast)

  return {
    label: {
      color: contrastColor,
      font: theme.other.fonts.desktop.s.xs.important,
      [mediaHelper.greaterThen('sm')]: {
        font: theme.other.fonts.desktop.s.s.important,
      },
      textTransform: 'uppercase',
    },
    root: {
      minWidth: rem(24),
      backgroundColor: accent,
      borderRadius: rem(100),
      boxShadow: `0px 6px 10px 0px rgba(255, 255, 255, 0.80) inset`,
      [mediaHelper.greaterThen('sm')]: {
        minHeight: rem(32),
        padding: `${rem(6)} ${rem(10)}`,
      },
      minHeight: rem(24),
      padding: `${rem(3)} ${rem(8)}`,
    },
  }
})
